module.exports = __webpack_public_path__ + "img/certificate04-1.1d0d71fa.jpg";